__turbopack_context__.v({
  "blockScroller": "MessageBlock-module-scss-module__lXbNhq__blockScroller",
  "blocksBackgroundColor": "MessageBlock-module-scss-module__lXbNhq__blocksBackgroundColor",
  "blocksFontColor": "MessageBlock-module-scss-module__lXbNhq__blocksFontColor",
  "button": "MessageBlock-module-scss-module__lXbNhq__button",
  "h4": "MessageBlock-module-scss-module__lXbNhq__h4",
  "markdownEditor": "MessageBlock-module-scss-module__lXbNhq__markdownEditor",
  "messageItem": "MessageBlock-module-scss-module__lXbNhq__messageItem",
  "messageItemDivider": "MessageBlock-module-scss-module__lXbNhq__messageItemDivider",
  "messageList": "MessageBlock-module-scss-module__lXbNhq__messageList",
  "mobilePositionControls": "MessageBlock-module-scss-module__lXbNhq__mobilePositionControls",
  "multiItemHeader": "MessageBlock-module-scss-module__lXbNhq__multiItemHeader",
  "secondaryNavBackgroundColor": "MessageBlock-module-scss-module__lXbNhq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "MessageBlock-module-scss-module__lXbNhq__themeBackgroundColor",
  "themeFontColor": "MessageBlock-module-scss-module__lXbNhq__themeFontColor",
  "transitionEnter": "MessageBlock-module-scss-module__lXbNhq__transitionEnter",
  "transitionEnterActive": "MessageBlock-module-scss-module__lXbNhq__transitionEnterActive",
  "transitionEnterDone": "MessageBlock-module-scss-module__lXbNhq__transitionEnterDone",
  "transitionExit": "MessageBlock-module-scss-module__lXbNhq__transitionExit",
  "transitionExitActive": "MessageBlock-module-scss-module__lXbNhq__transitionExitActive",
  "transitionExitDone": "MessageBlock-module-scss-module__lXbNhq__transitionExitDone",
  "unsliderContainer": "MessageBlock-module-scss-module__lXbNhq__unsliderContainer",
});
